import { PoolAsset } from '../constants/poolAssets'
import { RISK_OPTIONS, PoolRisk } from '../constants/PoolRisk'
import { POOL_INVESTORS_COLLECTION } from '../utils/getPoolInvestorContract'
import { useMemo } from 'react'

const ENABLED_OPTIONS = [PoolRisk.HIGH, PoolRisk.MIDDLE]

export function useDepositRiskOptions(asset: PoolAsset | '' | undefined) {
  const options = useMemo(() => {
    if (!asset) return []
    const pools = POOL_INVESTORS_COLLECTION.filter(
      i => i.asset === asset && ENABLED_OPTIONS.includes(i.risk),
    )
    const result = pools.map(p => {
      return RISK_OPTIONS[p.risk]
    })
    return result
  }, [asset])

  return options
}
